var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.declaracao
      ? _c("div", [
          _c("p", [
            _vm._v(
              "Você pode pagar o boleto do seu aluguel ou das despesas do seu condomínio com cartão de crédito, em até 12 vezes."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Consulte, abaixo, a melhor opção de parcelamento.")
          ]),
          _vm._v(" "),
          _c("table", { attrs: { border: "0", cellspacing: "0" } }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.parcelas, function(parcela) {
                return _c(
                  "tr",
                  {
                    key: parcela.id,
                    class: { selected: _vm.installments == parcela.parcela },
                    on: {
                      click: function($event) {
                        _vm.installments = parcela.parcela
                      }
                    }
                  },
                  [
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          parcela.parcela == 1 ? "Rotativo" : parcela.parcela
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { align: "right" } }, [
                      _vm._v(_vm._s(_vm._f("number_format")(parcela.valor)))
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { align: "right" } }, [
                      _vm._v(_vm._s(_vm._f("number_format")(parcela.total)))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.declaracao ? _c("p", [_vm._m(1)]) : _vm._e(),
    _vm._v(" "),
    (!_vm.declaracao && _vm.showTermos) || true
      ? _c(
          "div",
          { staticClass: "termos" },
          [
            _c("p", [
              _vm._v(
                "Esse serviço está sujeito a encargos administrativos de transação, e de juros e IOF desde o momento de pagamento do boleto e que são devidos à operadora de seu cartão de crédito. Antes da contratação, consulte o CET (Custo Efetivo Total)."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "A Imobiliária " +
                  _vm._s(_vm.imobiliaria) +
                  " não se responsabiliza pelos encargos exigidos pela operadora de seu cartão de crédito. Ao aceitar o pagamento parcelado de seu boleto de aluguel ou condomínio através de seu cartão de crédito, você estará aceitando arcar com o pagamento dos encargos administrativos e financeiros que serão cobrados pela integradora e administradora do cartão de crédito, declarando também ter ciência que tais encargos não resultarão em qualquer benefício financeiro para locador, condomínio ou imobiliária, pois reverterão integralmente para as referidas empresas."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Bandeiras aceitas para esta operação: Visa, Mastercard, HiperCard."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Para efetivar a operação você deve se dirigir à sua unidade de atendimento."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Salientamos que trata-se de uma simulação e que os valores, percentuais e opções listadas acima deverão ser confirmados e validados no ato da efetivação da transação em sua unidade de atendimento."
              )
            ]),
            _vm._v(" "),
            _c("center", [
              _c(
                "button",
                {
                  staticClass: "btn-blue default-button",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.fechar($event)
                    }
                  }
                },
                [_vm._v("FECHAR")]
              )
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Parcelas")]),
        _vm._v(" "),
        _c("th", { attrs: { align: "right" } }, [_vm._v("Valor (R$)")]),
        _vm._v(" "),
        _c("th", { attrs: { align: "right" } }, [_vm._v("Total (R$)")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("b", [_vm._v("Leia os termos e condições")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }